import React from "react";
import "./styles.css";
import Parent from "./Parent.js";

export default function App() {
  return (
    <div className="App">
      <Parent />
    </div>
  );
}
